<template>

    <Head title="Tambah Data Kunjungan" />
    <div class="card card-outline card-primary">
        <div class="card-header">
            <h1 class="card-title">TAMBAH DATA KUNJUNGAN</h1>
            <div class="card-tools">
                <Link class="btn btn-tool" href="/kunjungan">
                <i class="fas fa-times"></i>
                </Link>
            </div>
        </div>
        <form @submit.prevent="submit">
            <div class="card-body">
                <div v-if="bayar > 0" class="alert alert-danger">
                    Sudah terbayar {{ formatRibuan(bayar) }}
                </div>
                <div class="row">
                    <div class="col-sm-6">
                        <input-select2 v-model="form.rek" :error="form.errors.rek" label="Nama" :options="debiturs"
                            :settings="{
                                placeholder: 'Pilih data ...',
                                allowClear: true,
                            }" id="rekening">
                        </input-select2>
                        <text-area label="Alamat" readonly id="alamat" />
                        <div class="row">
                            <div class="col-sm">
                                <input-text label="Titipan" readonly id="titipan" />
                            </div>
                            <div class="col-sm">
                                <input-text label="Tunggakan" readonly id="tunggakan" />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm">
                                <input-text label="Masa Angsuran" readonly id="masa_angsuran" />
                            </div>
                            <div class="col-sm">
                                <input-text label="Angsuran" readonly id="angsuran" />
                            </div>
                        </div>
                        <text-area label="Jaminan" readonly id="jaminan" />
                        <div class="row">
                            <div class="col-sm">
                                <input-text label="Macet" readonly id="bln_tung" />
                            </div>
                            <div class="col-sm">
                                <datescope label="Tanggal Janji" v-model="form.tgl_janji" :error="form.errors.tgl_janji"
                                    class="fas fa-calendar-alt" />
                            </div>
                        </div>
                        <text-area label="Keterangan" v-model="form.keterangan" :error="form.errors.keterangan" />
                    </div>
                    <div class="col-sm-6">
                        <file-pond name="imageFilepond" ref="pond" :allow-multiple="true" max-files="2"
                            accepted-file-types="image/png, image/jpeg"
                            label-idle="Letakkan gambar disini, atau <span class='filepond--label-action'>jelajahi</span>"
                            :server="{
                                url: '',
                                timeout: 7000,
                                process: {
                                    url: '/upload',
                                    method: 'POST',
                                    headers: {
                                        'X-CSRF-TOKEN': $page.props.csrf
                                    },
                                    withCredentials: false,
                                    onload: handleFilePondLoad,
                                    onerror: () => { }
                                },
                                remove: handleFilePondRemove,
                                revert: handleFilePondRevert
                            }" imagePreviewHeight="260" imageResizeMode="force" imageResizeTargetWidth="600"
                            imageResizeTargetHeight="800" styleLoadIndicatorPosition="right bottom"
                            styleProgressIndicatorPosition="right bottom" styleButtonProcessItemPosition="right bottom"
                            styleButtonRemoveItemPosition="left bottom">
                        </file-pond>
                    </div>
                </div>
            </div>
            <div class="card-footer">
                <button type="submit" class="btn btn-primary" :disabled="form.processing">Simpan</button>
            </div>
        </form>
    </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3'
import Layout from "@/Layouts/Master"
import InputText from '@/Forms/InputText'
import InputFile from '@/Forms/InputFile'
import TextArea from '@/Forms/TextArea'
import InputSelect2 from '@/Forms/InputSelect2'
import Datescope from '@/Forms/Datescope'
import moment from 'moment'
moment.locale('id')

// Import Vue FilePond
import vueFilePond from 'vue-filepond';

// Import FilePond styles
import "filepond/dist/filepond.min.css";

// Import FilePond plugins
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import FilePondPluginImageResize from 'filepond-plugin-image-resize';
import FilePondPluginImageTransform from 'filepond-plugin-image-transform';
import FilePondPluginImageCrop from 'filepond-plugin-image-crop';

// Import image preview plugin styles
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";
import 'filepond-plugin-file-poster/dist/filepond-plugin-file-poster.css';

// Create component
const FilePond = vueFilePond(
    FilePondPluginFileValidateType,
    FilePondPluginImagePreview,
    FilePondPluginImageResize,
    FilePondPluginImageTransform,
    FilePondPluginImageCrop,
);

export default {
    layout: Layout,
    components: {
        Head,
        Link,
        InputText,
        InputFile,
        TextArea,
        InputSelect2,
        Datescope,
        FilePond,
    },
    props: {
        debiturs: Array,
    },
    data() {
        return {
            form: this.$inertia.form({
                rek: null,
                keterangan: null,
                tgl_janji: moment(new Date()).subtract(1, 'd').format("DD-MM-YYYY"),
                image: null,
                lat: '',
                lng: '',
            }),
            bayar: 0,
        }
    },
    methods: {
        formatRibuan(num) {
            return num.toLocaleString('id-ID');
        },
        submit() {
            this.form.post('/kunjungan', {
                forceFormData: true,
                preserveScroll: true,
                onSuccess: () => {
                    toastr.success('Tambah Kunjungan berhasil', 'SUKSES')
                }
            })
        },
        handleFilePondLoad(response) {
            this.addFormImage(response);
            return response;
        },
        handleFilePondRemove(source, load, error) {
            this.removeFormImage(source.replace(/^\//, ''));
            load();
        },
        handleFilePondRevert(uniqueId, load, error) {
            this.removeFormImage(uniqueId);
            this.$inertia.post('/revert', {
                image: uniqueId
            });
            load();
        },
        addFormImage(image) {
            let arr = this.form.image ? this.form.image.split('|') : [];
            arr.push(image);
            this.form.image = arr.join('|');
            console.log(this.form.image);
        },
        removeFormImage(image) {
            let arr = this.form.image ? this.form.image.split('|') : [];
            arr.remove(basename(image));
            this.form.image = arr.join('|');
        },
        getDistance(position) {
            this.form.lat = position.coords.latitude.toFixed(7);
            this.form.lng = position.coords.longitude.toFixed(7);
        },
        getLocation() {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(this.getDistance);
            } else {
                x.innerHTML = "Geolocation is not supported by this browser.";
            }
        },
    },
    mounted() {
        const vm = this; // Simpan referensi instance Vue

        $('#rekening').on('change', function () {
            let data = $(this).val(); // gunakan this jQuery handler
            $.get("/kunjungan/" + data + "/cari", (hasil) => {
                $('#alamat').val(hasil.alamat);
                $('#bln_tung').val(hasil.bln_tung);
                $('#titipan').val(hasil.titipan);
                $('#tunggakan').val(hasil.tunggakan);
                $('#masa_angsuran').val(hasil.masa_angsuran);
                $('#angsuran').val(hasil.angsuran);
                $('#jaminan').val(hasil.jaminan);
                vm.bayar = Number(hasil.uang_masuk) + Number(hasil.uang_titipan); // pakai vm supaya reactive
            });
        });
        this.getLocation();
    }
}

function basename(path) {
    return path.split('/').reverse()[0];
}

Array.prototype.remove = function () {
    var what, a = arguments, L = a.length, ax;
    while (L && this.length) {
        what = a[--L];
        while ((ax = this.indexOf(what)) !== -1) {
            this.splice(ax, 1);
        }
    }
    return this;
};
</script>